module.exports = __webpack_public_path__ + "static/media/thumbnail.cbfa6649.jpg";